<template>
  <div class="kit-plans card card-shrink">
        <div class="header">
            <button class="button item-btn" @click="$emit('back')"><font-awesome-icon :icon="['fa', 'arrow-left']"/> Voltar</button>
            <button class="button btn-primary btn-min" @click="$emit('changeView', 'rsl')">Resultados</button>
            <button class="button btn-primary btn-min" @click="$emit('changeView', 'rsk')">Riscos de Saúde</button>
            <button class="button btn-primary btn-min" @click="$emit('changeView', 'tps')">Dicas</button>
            <button class="button btn-primary btn-min" @click="$emit('download', result.id, result.exam.lab_document_id)">Laudo</button>
        </div>
        <modal v-if="modal" @close="modal = false" :title="modalImg == 'al' ? 'Pirâmide Alimentar' : 'Pirâmide de Atividades'" :img="modalImg"></modal>
        <span class="title">Plano de cuidado</span>
        <h2>{{result.kit_type.name}}</h2>
            Agora que já conhecemos os detalhes da sua saúde, traçamos um plano de cuidado preventivo,
            para evitar que você desenvolva certas doenças e para evitar riscos atrelados a saúde.
            O plano de cuidado está pautado em 3 pilares: <br>
        <div class="pillar-text">
            <span class="pillar-rep">I</span> hábitos de vida, pois eles são os principais
            responsáveis para o desenvolvimento da maioria das doenças; <br>
            <span class="pillar-rep">II</span> rotina personalizada, considerando os seu diagnóstico preliminar, riscos saúde e fatores preliminares; <br>
            <span class="pillar-rep">III</span> e exames preventivos necessários e que consideram a sua idade como parâmetro.
        </div>
        <div class="pillar">
            <div class="pillar-content">
                <img class="pillar-icon" src="@/assets/images/kit-plans/icons/Ativ.físicas.png">
                <div>
                    <span>Praticar atividade física 30 minutos por dia e 5 vezes na semana. Respeite as suas limitações e pratique exercícios de acordo com a sua idade e condições físicas. Aqui o importante é a constância.</span>
                    <font-awesome-icon class="question-mark" :icon="['fa', 'question-circle']" @click="openModal('at')"/>
                </div>
            </div>
        </div>
        <div class="pillar">
            <div class="pillar-content">
                <img class="pillar-icon" src="@/assets/images/kit-plans/icons/Alimentos.png">
                <div>
                    <span>Cuide da sua alimentação. Não comer frituras e gorduras com frequência ou em excesso. Coma frutas, legumes, verduras e cereais diariamente. Diminua o sal nas refeições. Evite doces e alimentos processados.</span>
                    <font-awesome-icon class="question-mark" :icon="['fa', 'question-circle']" @click="openModal('al')"/>
                </div>
            </div>
        </div>
        <div class="pillar">
            <div class="pillar-content">
                <img class="pillar-icon" src="@/assets/images/kit-plans/icons/Rotina Personalizada.png">
                <div>
                    <span>Cuidar da saúde preventivamente é o que vai fazer com que você esteja sempre na melhor versão. Desenvolvemos uma rotina preventiva com profissionais de saúde. Considerando todos os dados e resultados, recomendamos que visite um(a)
                        <span v-if="typeof preventionSpecialists['3'] != 'undefined' && preventionSpecialists['3'].length > 0 ">
                            <span class="prevention" v-for="item in preventionSpecialists['3']" :key="item">
                                <span v-if="preventionSpecialists['3'].at(-1) != item">
                                    {{ item }},
                                </span>
                                <span v-if="preventionSpecialists['3'].at(-1) == item && preventionSpecialists['3'].length > 1">
                                    e {{ item }}
                                </span>
                                <span v-if="preventionSpecialists['3'].length == 1">
                                    {{ item }}
                                </span>
                            </span>
                            <span v-if="preventionSpecialists['6'].length > 0 || preventionSpecialists['12'].length > 0 || preventionSpecialists['24'].length > 0">
                                a cada 3 meses;
                            </span>
                            <span v-else>
                                a cada 3 meses.
                            </span>
                        </span>

                        <span v-if="typeof preventionSpecialists['6'] != 'undefined' && preventionSpecialists['6'].length > 0 ">
                            <span class="prevention" v-for="item in preventionSpecialists['6']" :key="item">
                                <span v-if="preventionSpecialists['6'].at(-1) != item">
                                    {{ item }},
                                </span>
                                <span v-if="preventionSpecialists['6'].at(-1) == item && preventionSpecialists['6'].length > 1">
                                    e {{ item }}
                                </span>
                                <span v-if="preventionSpecialists['6'].length == 1">
                                    {{ item }}
                                </span>
                            </span>
                            <span v-if="preventionSpecialists['12'].length > 0 || preventionSpecialists['24'].length > 0">
                                a cada 6 meses;
                            </span>
                            <span v-else>
                                a cada 6 meses.
                            </span>
                        </span>

                        <span v-if="typeof preventionSpecialists['12'] != 'undefined' && preventionSpecialists['12'].length > 0 ">
                            <span class="prevention" v-for="item in preventionSpecialists['12']" :key="item">
                                <span v-if="preventionSpecialists['12'].at(-1) != item">
                                    {{ item }},
                                </span>
                                <span v-if="preventionSpecialists['12'].at(-1) == item && preventionSpecialists['12'].length > 1">
                                    e {{ item }}
                                </span>
                                <span v-if="preventionSpecialists['12'].length == 1">
                                    {{ item }}
                                </span>
                            </span>
                            <span v-if="preventionSpecialists['24'].length > 0">
                                a cada 12 meses;
                            </span>
                            <span v-else>
                                a cada 12 meses.
                            </span>
                        </span>

                        <span v-if="typeof preventionSpecialists['24'] != 'undefined' && preventionSpecialists['24'].length > 0 ">
                            <span class="prevention" v-for="item in preventionSpecialists['24']" :key="item">
                                <span v-if="preventionSpecialists['24'].at(-1) != item">
                                    {{ item }},
                                </span>
                                <span v-if="preventionSpecialists['24'].at(-1) == item && preventionSpecialists['24'].length > 1">
                                    e {{ item }}
                                </span>
                                <span v-if="preventionSpecialists['24'].length == 1">
                                    {{ item }}
                                </span>
                            </span>
                            <span>
                                a cada 24 meses.
                            </span>
                        </span>
                    </span>

                    <a href="https://bvsms.saude.gov.br/check-up-medico/" target="blank">
                        <font-awesome-icon class="question-mark" :icon="['fa', 'question-circle']"/>
                    </a>
                </div>
            </div>
        </div>
        <div class="pillar">
            <div class="pillar-content">
                <img class="pillar-icon" src="@/assets/images/kit-plans/icons/Exames Preventivos.png">
                <div>
                    <span>Aqui elencamos os principais exames preventivos para ajudar você manter seu Checkup Saúde sempre em dia, considerando a sua idade, gênero e resultados. Realize exames laboratoriais para verificar
                        <span v-if="typeof preventionExams['3'] != 'undefined' && preventionExams['3'].length > 0 ">
                            <span class="prevention" v-for="item in preventionSpecialists['3']" :key="item">
                                <span v-if="preventionExams['3'].at(-1) != item">
                                    {{ item }},
                                </span>
                                <span v-if="preventionExams['3'].at(-1) == item && preventionExams['3'].length > 1">
                                    e {{ item }}
                                </span>
                                <span v-if="preventionExams['3'].length == 1">
                                    {{ item }}
                                </span>
                            </span>
                            <span v-if="preventionExams['6'].length > 0 || preventionExams['12'].length > 0 || preventionExams['24'].length > 0">
                                a cada 3 meses;
                            </span>
                            <span v-else>
                                a cada 3 meses.
                            </span>
                        </span>

                        <span v-if="typeof preventionExams['6'] != 'undefined' && preventionExams['6'].length > 0 ">
                            <span class="prevention" v-for="item in preventionExams['6']" :key="item">
                                <span v-if="preventionExams['6'].at(-1) != item">
                                    {{ item }},
                                </span>
                                <span v-if="preventionExams['6'].at(-1) == item && preventionExams['6'].length > 1">
                                    e {{ item }}
                                </span>
                                <span v-if="preventionExams['6'].length == 1">
                                    {{ item }}
                                </span>
                            </span>
                            <span v-if="preventionExams['12'].length > 0 || preventionExams['24'].length > 0">
                                a cada 6 meses;
                            </span>
                            <span v-else>
                                a cada 6 meses.
                            </span>
                        </span>

                        <span v-if="typeof preventionExams['12'] != 'undefined' && preventionExams['12'].length > 0 ">
                            <span class="prevention" v-for="item in preventionExams['12']" :key="item">
                                <span v-if="preventionExams['12'].at(-1) != item">
                                    {{ item }},
                                </span>
                                <span v-if="preventionExams['12'].at(-1) == item && preventionExams['12'].length > 1">
                                    e {{ item }}
                                </span>
                                <span v-if="preventionExams['12'].length == 1">
                                    {{ item }}
                                </span>
                            </span>
                            <span v-if="preventionExams['24'].length > 0">
                                a cada 12 meses;
                            </span>
                            <span v-else>
                                a cada 12 meses.
                            </span>
                        </span>

                        <span v-if="typeof preventionExams['24'] != 'undefined' && preventionExams['24'].length > 0 ">
                            <span class="prevention" v-for="item in preventionExams['24']" :key="item">
                                <span v-if="preventionExams['24'].at(-1) != item">
                                    {{ item }},
                                </span>
                                <span v-if="preventionExams['24'].at(-1) == item && preventionExams['24'].length > 1">
                                    e {{ item }}
                                </span>
                                <span v-if="preventionExams['24'].length == 1">
                                    {{ item }}
                                </span>
                            </span>
                            <span>
                                a cada 24 meses.
                            </span>
                        </span>
                    </span>
                    <a href="https://bvsms.saude.gov.br/check-up-medico/" target="blank">
                        <font-awesome-icon class="question-mark" :icon="['fa', 'question-circle']"/>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <!-- <loading-screen v-if="loading" /> -->
</template>
<script>
    import { GET_KIT_ANSWERS } from '../../services/kit';
    import Modal from './Modal';

    import { library } from '@fortawesome/fontawesome-svg-core'
    import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'

    library.add(faQuestionCircle);

    export default {
        name: "kit-plans",
        components: { Modal },
        props: {
            result: Object,
        },
        data() {
            return {
                loading: false,
                metrics: null,
                fMetrics: [],
                formAnswers: [],
                riskModal: {},
                riskModalOpen: false,
                preventionExams: [],
                preventionSpecialists: [],
                hasHeartDisease: false,
                hasDiabetes: false,
                hasHypertension: false,
                hasAvc: false,
                hasDyslipidimia: false,
                hasMetabolic: false,
                hasOsteoporosis: false,
                modal: false,
                modalImg: null,
            };
        },
        methods: {
            back() {
                this.$emit('back');
            },
            async loadKit(kit_id) {
                try {
                    this.loading = true;
                    const data = await GET_KIT_ANSWERS(kit_id);
                    this.metrics = data.metric;
                    this.formAnswers = data.field_answers;
                    this.formAnswers.filter((a) => {
                        return a.field.id == 'afaf2530-c963-4907-a519-9e2eef07bddc';
                    })
                    if(this.formAnswers.length > 0) {
                        this.hasHeartDisease = this.answerSearch('Você é portador de alguma doença do coração?') == 'Sim' ? true : false;
                        this.hasDiabetes =
                            (
                                this.answerSearch('Você é portador de Diabetes?') == 'Sim, Descontrolada' ||
                                this.answerSearch('Você é portador de Diabetes?') == 'Sim, Controlada') ? true : false;
                        this.hasHypertension = this.answerSearch('Você é portador de Hipertensão?') != 'Não' ? true : false;
                        this.hasAvc = this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true).includes('avc') ? true : false;
                        this.hasDyslipidimia = this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true).includes('dislipidemia') ? true : false;

                        this.hasOsteoporosis = this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true).includes('Osteoporose') ? true : false;
                    }

                }catch(err) {
                    console.log(err);
                } finally {
                    this.loading = false;
                }
            },
            openModal(img) {
                this.modalImg = img;
                return this.modal = true;
            },

            getUserExams() {
                let userGender = this.result.customer.gender;
                let userAge = this.result.customer.age;
                if(userGender == 'M') {
                    if(userAge >= 40) {
                        this.addPrevention('colesterol, triglicerídeos e glicose', '6', 'ex');
                        this.addPrevention('prostata', '12', 'ex');
                        this.addPrevention('ecocardiograma / raio-x do tórax e ultrasom do coração', '12', 'ex');
                        this.addPrevention('colonoscopia', '12', 'ex');
                    }else {
                        this.addPrevention('colesterol, triglicerídeos e glicose', '12', 'ex');
                    }
                }else if(userGender == 'F') {
                    if(userAge >= 40) {
                        this.addPrevention('colesterol, triglicerídeos e glicose', '6', 'ex');
                        this.addPrevention('mamografia', '12', 'ex');
                        this.addPrevention('densiometria óssea', '24', 'ex');
                        this.addPrevention('papanicolau', '12', 'ex');
                        this.addPrevention('ecocardiograma / raio-x do tórax e ultrasom do coração', '12', 'ex');
                        this.addPrevention('colonoscopia', '12', 'ex');
                    } else {
                        this.addPrevention('colesterol, triglicerídeos e glicose', '12', 'ex');
                        this.addPrevention('mamografia', '12', 'ex');
                        this.addPrevention('papanicolau', '12', 'ex');
                    }
                }

                if(this.hasHeartDisease) {
                    this.addPrevention('cardiologista', '6', 'es');
                    this.addPrevention('nutricionista', '3', 'es');
                }
                if(this.hasDiabetes) {
                    this.addPrevention('endocrinologista', '3', 'es');
                    this.addPrevention('nutricionista', '3', 'es');
                }
                if(this.hasHypertension) {
                    this.addPrevention('cardiologista', '3', 'es');
                    this.addPrevention('nutricionista', '3', 'es');
                }
                if(this.hasAvc) {
                    this.addPrevention('neurologista', '6', 'es');
                    this.addPrevention('cardiologista', '6', 'es');
                    this.addPrevention('nutricionista', '3', 'es');
                }
                if(this.hasDyslipidimia) {
                    this.addPrevention('cardiologista', '6', 'es');
                    this.addPrevention('endocrinologista', '6', 'es');
                    this.addPrevention('nutricionista', '3', 'es');
                }
                if(this.hasMetabolic) {
                    this.addPrevention('endocrinologista', '3 a 6', 'es');
                    this.addPrevention('cardiologista', '3 a 6', 'es');
                    this.addPrevention('nutricionista', '3', 'es');
                }
                if(this.hasOsteoporosis) {
                    this.addPrevention('reumatologista', '3 a 6', 'es');
                    this.addPrevention('ortopedista', '3 a 6', 'es');
                    this.addPrevention('ginecologista', '12', 'es');
                    this.addPrevention('nutricionista', '3', 'es');
                }

                if(
                    !this.hasHeartDisease &&
                    !this.hasDiabetes &&
                    !this.hasHypertension &&
                    !this.hasAvc &&
                    !this.hasDyslipidimia &&
                    !this.hasMetabolic &&
                    !this.hasOsteoporosis
                )
                    this.addPrevention('clinico geral', '12', 'es');

            },
            addPrevention(prevention, period, type) {
                let insert = true;

                if(type == 'es'){
                    this.preventionSpecialists.map((interval, x) =>{
                        interval.map((item, i)=>{
                            if(item == prevention){
                                if(x <= period){
                                    insert = false
                                } else{
                                    this.preventionSpecialists[x].splice(i, 1);
                                }
                            }
                        })
                    })
                    if(insert){
                        this.preventionSpecialists[period].push(prevention);
                    }
                }


                if(type == 'ex'){
                    this.preventionExams.map((interval, x) =>{
                        interval.map((item, i)=>{
                            if(item == prevention){
                                if(x <= period){
                                    insert = false
                                } else{
                                    this.preventionExams[x].splice(i, 1);
                                }
                            }
                        })
                    })
                    if(insert){
                        this.preventionExams[period].push(prevention);
                    }
                }
            },
            answerSearch(field, multiple = false, answers = []) {
                let ans = null
                if(multiple) {
                    if(answers.length > 0) {
                        ans = this.formAnswers.filter(a => {
                            return a.field.title == field && answers.includes(a.option.value);
                        }).map(a => {
                            return a.option.value;
                        });
                        return ans.join(', ');
                    }else {
                        ans = this.formAnswers.filter(a => {
                            return a.field.title == field;
                        }).map(a => {
                            return a.option.value;
                        });
                        return ans;
                    }
                }else {
                    this.formAnswers.map(answer => {
                        if(answer.field.title == field && !multiple)
                            ans = answer.response !== null ? answer.response : answer.option.label;
                    });
                }
                return ans;
            },
        },
        async mounted() {
            await this.loadKit(this.result.id);
            this.$forceUpdate();

            this.preventionExams['3'] = [];
            this.preventionExams['6'] = [];
            this.preventionExams['12'] = [];
            this.preventionExams['24'] = [];
            this.preventionSpecialists['3'] = [];
            this.preventionSpecialists['6'] = [];
            this.preventionSpecialists['12'] = [];
            this.preventionSpecialists['24'] = [];
            this.getUserExams();
        },
    }
</script>
<style scoped>
  @import "./kit-plans.scss";
  @import "./responsive.css";
</style>



// WEBPACK FOOTER //
// src/components/KitPlans/KitPlans.vue